export class Group {
    constructor(group) {
        this.isInCurrentCustomer = false;
        this.id                  = group.id;
        this.name                = group.name;
        this.status              = group.status;
        this.description         = group.description;
    }

    changeStatusInCurrentCustomer() {
        this.isInCurrentCustomer = !this.isInCurrentCustomer;
        // if(!this.isInCurrentCustomer) {
        //     this.isInCurrentCustomer = !this.isInCurrentCustomer;
        // }
    }
    changeStatusFalse() {
        this.isInCurrentCustomer = false;
    }
}
